var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"to-top",on:{"click":_vm.toTop}},[_c('img',{attrs:{"src":require("../assets/imgs/to_top.png"),"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }